export default __webpack_public_path__ + "static/media/ConferenceIcon.08de7c2e.svg";